<template>
  <section>
    <div class="row">
      <div class="col-md-12 custom-header">
        <div class="input-group custom-title">
          <h4>Zone Progress</h4>
          <button class="btn btn-link" @click="editGoals">
            <i class="fas fa-pencil-alt"></i>
          </button>
        </div>
        <week-selector
          v-if="showWeekChooser"
          class="custom-selector"
          :weeks="weeks"
          :week="week"
          @change="weekChanged"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-4">
        <progress-goals />
      </div>
      <div class="col-md-4">
        <progress-zone-piechart />
      </div>
      <div class="col-md-4">
        <progress-zone-daily />
      </div>
    </div>
  </section>
  <set-cardio-goals
    :show="actionCardio"
    @close="closeDialogs"
    @changed="changed"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import WeekSelector from '../elements/week-selector'
import ProgressGoals from './progress/progress-goals'
import ProgressZonePiechart from './progress/progress-zone-piechart'
import ProgressZoneDaily from './progress/progress-zone-daily'
import SetCardioGoals from '../actions/set-cardio-goals'
export default {
  name: 'client-progress',
  components: {
    WeekSelector,
    ProgressGoals,
    ProgressZoneDaily,
    ProgressZonePiechart,
    SetCardioGoals,
  },
  props: {
    showWeekChooser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actionCardio: null,
    }
  },
  mounted() {
    this.weekChanged()
  },
  emits: ['weekChanged', 'changed'],
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.week.name
      }
      return _data
    },
    date() {
      let _data = ''
      if (this.summary) {
        // TODO: remove subtraction for Production
        _data = moment(this.summary.week.value)
          // .subtract(4, 'years')
          .format('YYYY-MM-DD')
        // _data = moment(this.summary.week.value).format('YYYY-MM-DD')
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', ['getMember', 'getMemberGoals']),
    async closeDialogs() {
      this.actionCardio = null
      await this.refreshGoals()
    },
    changed() {
      this.$emit('changed')
    },
    editGoals() {
      this.actionCardio = {
        id: this.member.id,
        date: this.date,
        isMultiple: false,
      }
    },
    async refreshGoals() {
      if (this.member === undefined || this.member === null) {
        await this.getMember({
          id: this.member.id,
          date: this.date,
        })
      }
      await this.getMemberGoals({
        id: this.member.id,
        date: this.date,
      })
    },
    async weekChanged(week) {
      await this.refreshGoals()
      this.$emit('weekChanged', this.date)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  position: relative;
}
.custom-title {
  position: absolute;
  left: 0;
  top: 0;
  button {
    top: -10px;
  }
}
.custom-selector {
  width: 265px;
  margin: 0 auto;
}
</style>
